<template>
  <List
    :loading="loading"
    :data="data"
    :error="error">
      <template v-slot="{item}">
        <div class="linkItem" :key="item.id">
          <a :href="item.link" target="_blank">{{item.name}}</a>
        </div>
      </template>
  </List>
</template>

<script>
import { List } from 'components/common';
export default {
  components: {
    List,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    error: {
      type: Error,
      default: null,
    },
  },
}
</script>

<style lang="less" scoped>
  @import url('~@/assets/styles/vars.less');

  .friendshipLinks {
    margin-top: 12px;
  }
  .linkItem {
    margin-bottom: @margin-small;
    &:last-of-type {
      margin-bottom: 0;
    }
    a {
      color: @color-text-link;
      font-size: 20px;
      font-family: @font-fm-zh;
      font-weight: bold;
      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>
